<template>
  <div class="company-management-container">

    <div class="company-list">
      
      <div class="company" @click="clearSelectedCompany()" :class="{ active: selectedCompany === 0 }" >All bots</div>

      <div v-for="company in allCompanies"
        :key="company.id"
        class="company"
        @click="selectCompany(company.id)"
        :class="{ active: company.id === selectedCompany }" >
        <span class="company-name">{{company.name}}</span>
      </div>

    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters(["allCompanies", "selectedCompany"]),
  },
  mounted() {
    this.getCompanies();
  },
  methods: {
    ...mapActions([ "getCompanies", "selectCompany"]),
    clearSelectedCompany() { this.selectCompany(0) },
    isActive(id) { return this.selectedCompany === id }
  },
  components: {},
};
</script>

<style lang="scss">
.company-management-container {
  width: 100%;
  height: calc(100vh - 60px);

  .company-list {
    width: 100%;
    padding: 20px 0;

    height: calc(100vh - 60px);
    overflow: scroll;

    .company {
      width: 100%;
      font-size: 14px;
      padding: 10px 1.25em 10px 1.25em;

      cursor: pointer;

      display: flex;
      justify-content: space-between;
      align-items: center;

      transition: color 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      transition: background-color 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

      .company-name {
        width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .cm-container {
        position: relative;
        .cm-button { 
          opacity: 0;
        }
        .cm-menu {
          position: absolute;
          right: 0;
          width: 110px;
        }
      }
      

      &.active {
        background-color: #323232;
        color: rgba($color: #ffffff, $alpha: 0.85);
        font-weight: 500;
      }
      &:hover {
        color: #fff;

        .cm-button {
          opacity: 0.5;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
